export const grayBorderedButton = {
  color:'black',
  '&::before': {
    content: '""',
    position: 'absolute',
    inset: 0,
    borderRadius: '6px',
    padding: '2px', //ajust the padding to change the width of the border radius
    border: '2px solid #C0C0C0',
    WebkitMaskComposite: 'xor',
    maskComposite: 'exclude',
  },
};